import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CloseIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="x-close" {...props} />;
};

export { CloseIcon };
